<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-image">
        <img src="@/assets/support-image.jpg" alt="Support System" />
      </div>
      <div class="login-form">
        <h2 class="support-heading">Support System Login</h2>
        <form @submit.prevent="handleLogin">
          <div class="input-group">
            <label for="email">Email</label>
            <input 
              type="email" 
              id="email" 
              v-model="email" 
              placeholder="Enter your email" 
              required
            />
          </div>

          <div class="input-group">
            <label for="password">Password</label>
            <input 
              type="password" 
              id="password" 
              v-model="password" 
              placeholder="Enter your password" 
              required
            />
          </div>

          <button type="submit" :disabled="isLoading">
            {{ isLoading ? 'Loading...' : 'Login' }}
          </button>

          <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Login } from '../../Helper/UserApiHelper';

export default {
  data() {
    return {
      email: '',
      password: '',
      isLoading: false,
      errorMessage: ''
    };
  },
  methods: {
    async handleLogin() {
      if (!this.email || !this.password) {
        this.errorMessage = "Email and Password are required!";
        return;
      }

      this.isLoading = true; 
      this.errorMessage = '';

      try {
        const loginData = { email: this.email, password: this.password };
        const response = await Login(loginData);
        console.log(response);
        if (response?.token) {
          this.$toasted.success(
            `Login successful! Welcome ${this.email}`, {
            theme: "outline",
            position: "bottom-center",
            duration: 3000,
          }
          );
          localStorage.setItem('userToken', response.token);
          this.$router.push('/user/support');
        } else {
          this.$toasted.error(
            response.message || "Invalid credentials!", {
                            icon: "exclamation-triangle",
                            theme: "outline",
                            position: "bottom-center",
                            singleton: true,
                            duration: 3000,
                        }
                    );
          // this.errorMessage = response.message || "Invalid credentials!";
        }
      } catch (error) {
        console.error("Login error:", error);
        this.$toasted.error(
                        "Something went wrong. Please try again!", {
                            icon: "exclamation-triangle",
                            theme: "outline",
                            position: "bottom-center",
                            singleton: true,
                            duration: 3000,
                        }
                    );
      } finally {
        this.isLoading = false; 
      }
    }
  }
};
</script>
  
  <style scoped>
  .support-heading{
    font-family: 'Times new roman';
  }
  .login-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    background: #f4f4f4;
  }
  .login-box {
    display: flex;
    flex-direction: row;
    background: white;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    max-width: 900px;
    width: 100%;
    overflow: hidden;
  }
  @media (max-width: 768px) {
    .login-box {
        width: 90%; /* Adjust width for smaller screens */
    }
}
  .login-image {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #007bff;
  }
  
  .login-image img {
    max-width: 100%;
    height: auto;
    object-fit: cover;
  }
  .login-form {
    flex: 1;
    padding: 40px;
    text-align: center;
  }
  
  h2 {
    margin-bottom: 20px;
    color: #333;
  }
  .input-group {
    margin-bottom: 15px;
    text-align: left;
  }
  
  .input-group label {
    display: block;
    margin-bottom: 5px;
    color: #666;
    font-weight: bold;
    font-family: 'Times new roman';
  }
  
  .input-group input {
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  button {
    width: 100%;
    padding: 12px;
    background: #007bff;
    border: none;
    color: white;
    font-size: 16px;
    border-radius: 5px;
    cursor: pointer;
    transition: background 0.3s;
  }
  
  button:hover {
    background: #0056b3;
  }
  @media (max-width: 768px) {
    .login-box {
      flex-direction: column;
    }
    
    .login-image {
      display: none; 
    }
    
    .login-form {
      padding: 30px;
    }
  }
</style>
  